import { Diagnostic, Patient } from "@/src/data/allTypes";
import { ReferenceFieldsForm } from "../fields/referenceFieldsForm";
import { ExamsCompartment } from "./examsCompartment";
import { MetastasisCompartment } from "./metastasisCompartment";
import { StoryCompartment } from "./storyCompartment";
import { getItemId, getUserId } from "@/src/utils/utils";
import { openDrawer } from "@/src/components/dialogs";
import apiFetch from "@/src/utils/apiFetch";
import { CompartmentCard } from "@/src/components/cards";
import { Input } from "@/src/components/universalInput";
function DiagnosticDrawer({
  patient,
  diagnostic,
  onChange,
}: {
  patient: Patient;
  diagnostic: Diagnostic;
  onChange: (newValue: Diagnostic) => void;
}) {
  return (
    <div className="c4 mc1 gap20">
      <CompartmentCard title={"Diagnostic"}>
        <ReferenceFieldsForm
          patient={patient}
          reference={diagnostic.reference}
          currentAnswers={diagnostic.content!.fieldAnswers || []}
          onChange={(newValue) => {
            diagnostic.content!.fieldAnswers = newValue;
            onChange(diagnostic);
          }}
        />
        <Input
          name="Notes"
          value={diagnostic.notes}
          type="textarea"
          rows={5}
          onChange={(newValue) => {
            diagnostic.notes = newValue;
            onChange(diagnostic);
          }}
        />
      </CompartmentCard>
      <StoryCompartment patient={patient} parentId={getItemId(diagnostic)} />
      <ExamsCompartment
        patient={patient}
        type="blue"
        parent={diagnostic}
        shouldShowSecondaryButton={false}
      />
      <MetastasisCompartment patient={patient} parent={diagnostic} />
    </div>
  );
}

export function openDiagnosticDrawer({
  patient,
  diagnostic,
  onSave,
}: {
  patient: Patient;
  diagnostic: Diagnostic;
  onSave: (newValue: Diagnostic) => void;
}) {
  diagnostic.content ||= {
    reference: diagnostic.reference,
    fieldAnswers: [],
    creator: getUserId(),
    patient: patient,
  };
  return openDrawer({
    id: "diagnosticDrawer",
    title: <div className="capitalize">{diagnostic.reference?.name}</div>,
    additionalClasses: ["big"],
    content: (
      <DiagnosticDrawer
        patient={patient}
        diagnostic={diagnostic}
        onChange={(newValue) => {
          diagnostic = newValue;
        }}
      />
    ),
    onConfirm: async () => {
      diagnostic = await apiFetch("diagnostics", "addOne", {
        diagnostic,
      });
      onSave(diagnostic);
    },
  });
}
